import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './ShopLocal.module.scss'
import AppConnector, { ConnectorProps as AppConnectorProps } from '../../connectors/App'
import DATA from 'data/shopLocal/countries.json'
const TITLE = 'Learn More'

const ShopLocal: FC<AppConnectorProps> = ({ userStoreCountry }) => {
  const countryData = DATA.find((item) => item.code === userStoreCountry)
  if (!countryData) {
    return null
  }

  const { code } = countryData

  return (
    <div className={styles.callout}>
      <div className={styles.titleSection}>
        <p className={styles.calloutTitle}>Collect More, Earn More</p>
        <p className={styles.calloutDescription}>
          {code === 'US'
            ? 'Spend $500 or more on original art and receive up to $300 in Saatchi Art credit.'
            : 'Spend $500 USD or more on original art and receive up to $300 USD in Saatchi Art credit.'}
        </p>
      </div>
      <SALink href='/rewards' title={TITLE}>
        <div className={styles.getStartedButton}>
          <p className={styles.buttonText}>{TITLE}</p>
        </div>
      </SALink>
    </div>
  )
}

export default AppConnector(ShopLocal)
